module.exports = __webpack_public_path__ + "static/media/main-section.06fe4633.svg";